import Vue from "vue";
import Vuex from "vuex";
import Order from "./modules/Order";
import RobotStatus from "./modules/RobotStatus";
import SocketIO from "./modules/SocketIO";

Vue.use(Vuex);

export default new Vuex.Store({ modules: { order: Order, robotStatus: RobotStatus, socketIO: SocketIO } });